/**
 * Deterministic seeded integer helper.
 * No Math.random(), no Date.now(), no new Date().
 */
export function seededInt(seed: string, min: number, max: number): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  // Map into [min, max] inclusive
  return min + (hash % (max - min + 1));
}
